import { OrganisationPreferenceRemote, OrganisationResponseInterface } from '@careapp/angular-sdk';
import { BrandingInterface, ColorSettingsInterface, FileRecordInterface } from '@careapp/angular-sdk/src';

import { CareAppListActionFactory } from './action-factory';

class OrganisationActions extends CareAppListActionFactory<OrganisationResponseInterface> {
  get REQUEST_OWN() {
    return `[${this.type}][Request] own`;
  }
  get RESPONSE_SUCCESS_OWN() {
    return `[${this.type}][Response][Success] own`;
  }
  get RESPONSE_FAIL_OWN() {
    return `[${this.type}][Response][Fail] own`;
  }
  get REQUEST_PREFERENCES() {
    return `[${this.type}][Request] Organisation Preferences`;
  }
  get RESPONSE_SUCCESS_PREFERENCES() {
    return `[${this.type}][Response][Success] Organisation Preferences`;
  }
  get RESPONSE_FAIL_PREFERENCES() {
    return `[${this.type}][Response][Fail] Organisation Preferences`;
  }
  get UPDATE_PREFERENCES() {
    return `[${this.type}][Request] Save Organisation Preferences`;
  }
  get SUCCESS_UPDATE_PREFERENCES() {
    return `[${this.type}][Response][Success] Save Organisation Preferences`;
  }
  get FAIL_UPDATE_PREFERENCES() {
    return `[${this.type}][Response][Fail] Save Organisation Preferences`;
  }
  get REQUEST_BRANDING() {
    return `[${this.type}][Request] Organisation Branding`;
  }
  get RESPONSE_SUCCESS_BRANDING() {
    return `[${this.type}][Response][Success] Organisation Branding`;
  }
  get RESPONSE_FAIL_BRANDING() {
    return `[${this.type}][Response][Fail] Organisation Branding`;
  }
  get UPDATE_BRANDING_COLORS() {
    return `[${this.type}][Request] Save Organisation Branding Colors`;
  }
  get RESET_BRANDING_COLORS() {
    return `[${this.type}][Request] Reset Organisation Branding Colors`;
  }
  get SUCCESS_UPDATE_BRANDING_COLORS() {
    return `[${this.type}][Response][Success] Save Organisation Branding Colors`;
  }
  get FAIL_UPDATE_BRANDING_COLORS() {
    return `[${this.type}][Response][Fail] Save Organisation Branding Colors`;
  }
  get UPDATE_BRANDING_IMAGE() {
    return `[${this.type}][Request] Save Organisation Branding Image`;
  }
  get REMOVE_BRANDING_IMAGE() {
    return `[${this.type}][Request] Remove Organisation Branding Image`;
  }
  get SUCCESS_UPDATE_BRANDING_IMAGE() {
    return `[${this.type}][Response][Success] Save Organisation Branding Image`;
  }
  get FAIL_UPDATE_BRANDING_IMAGE() {
    return `[${this.type}][Response][Fail] Save Organisation Branding Image`;
  }
  get NO_VALID_ORGANISATIONS() {
    return `[${this.type}][Fail] No Valid Organisations`;
  }

  RequestOwn() {
    return { type: this.REQUEST_OWN };
  }

  ResponseSuccessOwn(payload: OrganisationResponseInterface[]) {
    return { type: this.RESPONSE_SUCCESS_OWN, payload };
  }

  ResponseFailOwn(payload: Error) {
    return { type: this.RESPONSE_FAIL_OWN, payload };
  }

  RequestPreferences() {
    return { type: this.REQUEST_PREFERENCES };
  }

  ResponseSuccessPreferences(payload: OrganisationPreferenceRemote & { organisationId: string }) {
    return { type: this.RESPONSE_SUCCESS_PREFERENCES, payload };
  }

  ResponseFailPreferences(payload: any) {
    return { type: this.RESPONSE_FAIL_PREFERENCES, payload };
  }

  UpdatePreferences(payload: OrganisationPreferenceRemote) {
    return { type: this.UPDATE_PREFERENCES, payload };
  }

  SuccessUpdatePreferences(payload: OrganisationPreferenceRemote & { organisationId: string }) {
    return { type: this.SUCCESS_UPDATE_PREFERENCES, payload };
  }

  FailUpdatePreferences(payload: any) {
    return { type: this.FAIL_UPDATE_PREFERENCES, payload };
  }

  RequestBranding() {
    return { type: this.REQUEST_BRANDING };
  }

  ResponseSuccessBranding(payload: BrandingInterface & { organisationId: string }) {
    return { type: this.RESPONSE_SUCCESS_BRANDING, payload };
  }

  ResponseFailBranding(payload: any) {
    return { type: this.RESPONSE_FAIL_BRANDING, payload };
  }

  UpdateBrandingColors(payload: ColorSettingsInterface) {
    return { type: this.UPDATE_BRANDING_COLORS, payload };
  }

  RequestResetBrandingColors() {
    return { type: this.RESET_BRANDING_COLORS };
  }

  SuccessUpdateBrandingColors(payload: BrandingInterface & { organisationId: string }) {
    return { type: this.SUCCESS_UPDATE_BRANDING_COLORS, payload };
  }

  FailUpdateBrandingColors(payload: any) {
    return { type: this.FAIL_UPDATE_BRANDING_COLORS, payload };
  }

  UpdateBrandingImage(payload: FileRecordInterface) {
    return { type: this.UPDATE_BRANDING_IMAGE, payload };
  }

  RemoveBrandingImage(payload: FileRecordInterface) {
    return { type: this.REMOVE_BRANDING_IMAGE, payload };
  }

  SuccessUpdateBrandingImage(payload: BrandingInterface & { organisationId: string }) {
    return { type: this.SUCCESS_UPDATE_BRANDING_IMAGE, payload };
  }

  FailUpdateBrandingImage(payload: any) {
    return { type: this.FAIL_UPDATE_BRANDING_IMAGE, payload };
  }
  NoValidOrganisations() {
    return { type: this.NO_VALID_ORGANISATIONS };
  }

  constructor() {
    super(`Organisations`);
  }
}

export const Organisations = new OrganisationActions();
